@if (appState.priceModuleEnabled.getValue() && appState.priceSetting.getValue().PriceSetting === priceSetting.AllowSuggestedRetailPrice) {
<div class="price-request-container">

	@if (!isDoingPriceQuery && !fetchedPrice) {
	<button class="btn-outline round" (click)="getPrice()">
		{{ 'BAG.REQUEST-PRICE' | translate }}
	</button>
	}

	@if (isDoingPriceQuery) {
	<img class="loader" [src]="'/assets/animations/Framespinner.gif'" />
	}

	@if (!isDoingPriceQuery && fetchedPrice) {
	<div class="fetched-price">

		@if (!(fetchedPrice.priceFound || fetchedPrice.PriceFound)) {
		<span title="{{fetchedPrice.status?.message}}" class="text-italic">{{'BAG.NO-PRICE'|translate}}</span>
		}

		@if ((fetchedPrice.priceFound || fetchedPrice.PriceFound) && appState.priceSetting.getValue().PriceSetting === priceSetting.AllowSuggestedRetailPrice) {

		{{ ('BAG.PRICE.RETAIL' | translate) }}:

		@if (fetchedPrice.retailCurrencyCode) {
		{{fetchedPrice.retailCurrencyCode.toUpperCase()}}
		}
		@else if (fetchedPrice.RetailCurrencyCode) {
		{{fetchedPrice.RetailCurrencyCode.toUpperCase()}}
		}

		{{fetchedPrice.retailNetPrice | number:'1.2-2':currentLanguage}}

		}

		<button class="btn-primary close" (click)="reset()">
			<i class="fa-light fa-xmark"></i>
		</button>
	</div>
	}

</div>
}